import styles from './About.module.css'

export function About() {
  return (
    <section id='about' className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>About</h2>
        <div className={styles.columns}>
          <div className={styles.column}>
            <h3 className={styles.subheading}>Philosophy</h3>
            <p className={styles.text}>
              Fantasy Console 0 is inspired by the fantasy console tradition
              &mdash; a constrained creative environment that makes game
              development approachable and fun. Built with limitations that
              spark creativity: a fixed palette, a small screen, and a simple
              API let you focus on making something playable instead of
              wrestling with tooling.
            </p>
            {/* <p className={styles.text}>
              Everything runs in the browser. There&rsquo;s nothing to install,
              no build step, and no configuration. Just create a cart, write
              some code, and hit Run.
            </p> */}
          </div>
          <div className={styles.column}>
            <h3 className={styles.subheading}>Tech</h3>
            <p className={styles.text}>
              Games are plain JavaScript executed inside a sandboxed iframe. The
              runtime provides a small API for drawing sprites, reading input,
              playing sounds, doing simple math, and working with tile maps
              &mdash; all rendered to a 128&times;128px canvas.
            </p>
            <p className={styles.text}>
              Everything runs in the browser. There&rsquo;s nothing to install,
              no build step, and no configuration. Just create a cart, write
              some code, and hit Run.
            </p>
          </div>
        </div>

        <h3 className={`${styles.subheading} ${styles.constraintsHeading}`}>
          Constraints
        </h3>
        <p className={`${styles.text} ${styles.constraintsIntro}`}>
          Like all fantasy consoles, FC0 is intentionally limited. These
          constraints keep things simple and encourage creative problem-solving.
        </p>
        <div className={styles.constraints}>
          <div className={styles.constraint}>
            <span className={styles.constraintValue}>128&times;128px</span>
            <span className={styles.constraintLabel}>Screen resolution</span>
          </div>
          <div className={styles.constraint}>
            <span className={styles.constraintValue}>16 colors</span>
            <span className={styles.constraintLabel}>PICO-8 palette</span>
          </div>
          <div className={styles.constraint}>
            <span className={styles.constraintValue}>256 sprites</span>
            <span className={styles.constraintLabel}>
              8&times;8 pixels each
            </span>
          </div>
          <div className={styles.constraint}>
            <span className={styles.constraintValue}>128&times;64 tiles</span>
            <span className={styles.constraintLabel}>Tile map</span>
          </div>
          <div className={styles.constraint}>
            <span className={styles.constraintValue}>64 SFX</span>
            <span className={styles.constraintLabel}>4 audio channels</span>
          </div>
          <div className={styles.constraint}>
            <span className={styles.constraintValue}>9,999 tokens</span>
            <span className={styles.constraintLabel}>Code limit per cart</span>
          </div>
        </div>
      </div>
    </section>
  )
}
